import { render, staticRenderFns } from "./MeusAfiliados.vue?vue&type=template&id=3ef8ca20&scoped=true"
import script from "./MeusAfiliados.vue?vue&type=script&lang=js"
export * from "./MeusAfiliados.vue?vue&type=script&lang=js"
import style0 from "./MeusAfiliados.vue?vue&type=style&index=0&id=3ef8ca20&prod&lang=css"
import style1 from "./MeusAfiliados.vue?vue&type=style&index=1&id=3ef8ca20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef8ca20",
  null
  
)

export default component.exports